import {PageContainer} from '@vidazoo/ui-kit';
import DashboardsHeader from '../components/DashboardsHeader';
import DashboardsList from '../components/DashboardsList';
import {DashboardsListWithContext} from '../context/DashboardsListContext';
import theme from './theme.module.scss';

export default function Dashboards() {
    return <DashboardsListWithContext>
        <PageContainer pageTitle="Dashboards" top={1.2} className={theme.page}>
            <DashboardsHeader/>
            <DashboardsList/>
        </PageContainer>
    </DashboardsListWithContext>;
}
